<template>
  <div class="login-outer-container">
    <div class="ut-container-sm ut-pt-10 ">
      <info-card
        v-if="linkSent === true"
        :info="'The reset password link is on its way! Please check your inbox.'"
      />
      <agent-portal-login
        v-if="showLogin"
        @forgot-password="view = views.FORGOT_PASSWORD"
      />
      <agent-portal-forgot-password
        v-else-if="showForgotPassword"
        @back-to-login="view = views.LOGIN"
        @link-sent="linkSent = true"
      />
      <agent-portal-reset-password
        v-else-if="showResetPassword"
        @back-to-login="view = views.LOGIN"
      />
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex';
import AgentPortalLogin from '@/components/Login/AgentPortalLogin.vue';
import AgentPortalForgotPassword from '@/components/Login/AgentPortalForgotPassword.vue';
import AgentPortalResetPassword from '@/components/Login/AgentPortalResetPassword.vue';
import InfoCard from '@/components/Cards/InfoCard.vue';

const views = {
  LOGIN: 1,
  FORGOT_PASSWORD: 2,
  RESET_PASSWORD: 3,
};

export default {
  name: 'Login',
  props: {
    ak: String,
  },
  created() {
    this.$helpers.deleteCookie('user-key');
    if (this.$route.name === 'reset-password') {
      this.view = this.views.RESET_PASSWORD;
    }
  },
  mounted() {
    this.$store.subscribe((mutation) => {
      switch (mutation.type) {
        case 'agentStore/setAgent':
          if (!this.qa || `${this.qa.agentid}` !== `${this.agent.id}`) {
            // this.fetchQA();
          }
          break;
        default:
          break;
      }
    });
  },
  components: {
    AgentPortalLogin,
    AgentPortalForgotPassword,
    AgentPortalResetPassword,
    InfoCard,
  },
  data() {
    return {
      view: views.LOGIN,
      views,
      linkSent: false,
    };
  },
  computed: {
    ...mapState({
      user: state => state.userStore.user,
    }),
    showLogin() {
      return this.view === views.LOGIN;
    },
    showForgotPassword() {
      return this.view === views.FORGOT_PASSWORD;
    },
    showResetPassword() {
      return this.view === views.RESET_PASSWORD;
    },
  },
  methods: {

  },
};
</script>

<style scoped lang="scss">

.login-outer-container {
  @screen lg {
    margin-left: -280px;
  }
}
</style>
